module.exports = "/_next/static/assets/img/stats-coronavirus.com-fb7b7b6d0a56b782a6d12f4826d36663.jpg";